import React, { type FC, memo, useMemo } from 'react';

const leftAlignmentStyle: React.CSSProperties = {
  position: 'fixed',
  bottom: '40px',
  left: '240px',
  backgroundColor: 'rgba(0,0,0,0.5)',
  zIndex: 102,
  padding: '5px',
  float: 'right',
  fontSize: '14px',
  color: '#CCC',
};

const rightAlignmentStyle: React.CSSProperties = {
  position: 'fixed',
  bottom: '40px',
  right: '40px',
  backgroundColor: 'rgba(0,0,0,0.5)',
  zIndex: 102,
  padding: '5px',
  float: 'right',
  fontSize: '14px',
  color: '#CCC',
};

// eslint-disable-next-line react-refresh/only-export-components
export enum OverlayAlignment {
  left,
  right,
}

interface OverlayProps {
  alignment?: OverlayAlignment;
}

export const Overlay: FC<React.PropsWithChildren<OverlayProps>> = memo(
  ({ alignment = OverlayAlignment.left, children }) => {
    const styleObject = useMemo(
      () => (alignment === OverlayAlignment.left ? leftAlignmentStyle : rightAlignmentStyle),
      [alignment]
    );

    return <div style={styleObject}>{children}</div>;
  }
);
